import React from 'react'
import styles from './SubmitButton.module.scss'

interface SubmitButtonProps {
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  children, loading = false, disabled = false,
}) => (
  <button type="submit" disabled={loading || disabled} className={styles.button}>
    {loading && <span className={styles.spinner} />}
    {children}
  </button>
)
